import { createContext } from "react";

export type FeatureFlags = {
  enableAppInstallations: boolean;
};

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  enableAppInstallations: false,
};

export type FeatureFlagsContextType = {
  flags: FeatureFlags;
  loaded: boolean;
  updateFlag: (key: keyof FeatureFlags, value: boolean) => void;
  resetFlags: () => void;
};

export const FeatureFlagsContext = createContext<
  FeatureFlagsContextType | undefined
>(undefined);
